module.exports = __webpack_public_path__ + "static/media/loginLogo.6332e2ba.png";